import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "antd"; // or use any button you prefer
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SalesTaxSummary = (props) => {
  const { spTaxSummary, currency } = props;

  const exportToExcel = () => {
    if (!spTaxSummary || !spTaxSummary.length) return;

    const dataToExport = spTaxSummary.map((item) => ({
      "Item Name": item.itemName,
      "Item Type": item.itemType,
      Unit: item.unit,
      Quantity: item.quantity,
      Rate: `${currency} ${item.rate.toFixed(2)}`,
      "Total Tax": `${currency} ${(item.interTaxAmount + item.localTaxAmount + item.centralTaxAmount).toFixed(2)}`,
      "Total Amount": `${currency} ${item.totalAmount.toFixed(2)}`,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "SalesTaxSummary");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "SalesTaxSummary.xlsx");
  };

  return (
    <div
  className="card card-borderless p-0"
  style={{maxHeight: "600px",overflowY: "auto",overflowX: "hidden", }}>
  {spTaxSummary.length ? (
    <div style={{ overflowX: "auto" }}> 
      <table style={{width: "100%",borderCollapse: "collapse",tableLayout: "fixed",zIndex:"5" }}>
        <thead>
          <tr style={{ backgroundColor: "#EAF2E3" }}>
            {[
              spTaxSummary[0].invoiceNumber?.toString().trim().toUpperCase().startsWith("P")
                ? "Purchase Code"
                : "Invoice Number",
              "Company Name",
              "Item Name",
              "Unit",
              "Quantity",
              "Total Amount",
              "Total Tax",
            ].map((header, index) => (
              <th
                key={index}
                className={header.includes("Total") ? "text-end" : ""}
                style={{
                  fontWeight: "bold",
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#EAF2E3",
                  zIndex: 10,
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  padding: "8px",
                  textAlign: header.includes("Total") ? "right" : "left",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {spTaxSummary.map((item, index) => (
            <tr key={index}>
              <td style={{ wordBreak: "break-word", padding: "6px" }}>{item.invoiceNumber}</td>
              <td style={{ wordBreak: "break-word", padding: "6px" }}>{item.companyName}</td>
              <td style={{ wordBreak: "break-word", padding: "6px" }}>{item.itemName}</td>
              <td style={{ wordBreak: "break-word", padding: "6px" }}>{item.unit}</td>
              <td style={{ wordBreak: "break-word", padding: "6px" }}>{item.quantity}</td>
              <td
  className="text-end"
  style={{
    padding: "6px",
    borderRight: "none",
    borderLeft: "none",
    border: "none",
  }}
>
  {currency + " " + (item.totalAmount.toFixed(2))}
</td>
              <td
  className="text-end"
  style={{
    padding: "6px",
    border: "none",
  }}
>
  {currency + " " + (
    item.interTaxAmount +
    item.localTaxAmount +
    item.centralTaxAmount
  ).toFixed(2)}
</td>

            

            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div
      className="card card-borderless p-1 justify-content-center align-items-center text-center"
      style={{ height: "400px" }}
    >
      No data
    </div>
  )}
</div>

  
  );
};

export default SalesTaxSummary;